import { render } from "./LabelComponent.vue?vue&type=template&id=29681a8d&scoped=true"
import script from "./LabelComponent.vue?vue&type=script&lang=js"
export * from "./LabelComponent.vue?vue&type=script&lang=js"

import "./LabelComponent.vue?vue&type=style&index=0&id=29681a8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29681a8d"]])

export default __exports__